var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.22946 5.71509H13V7.08868H7.22946V13H5.65331V7.08868H0V5.71509H5.65331V0H7.22946V5.71509Z",
  fill: "black"
})));
export default SvgPlusIcon;